import { structureStatus } from './request';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false,
      type: ''
    };
  },
  computed: {
    dataRule() {
      return {
        reason: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('停用原因')
        }]
      };
    }
  },
  methods: {
    init(data, type) {
      this.dataFrom = {
        structureId: data.id,
        status: type ? 0 : 1,
        reason: ''
      };
      this.type = type;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          structureStatus(this.dataFrom).then(() => {
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};